import BreadCrumbs from 'components/breadcrumbs'
import { Card, CardBody } from 'reactstrap'
import TableProductionUnit from './TableProductionUnit'
import { useSelector } from 'react-redux'

const ProductionUnit = ({}) => {
  const { profile } = useSelector((s) => s.dashboard)
  return (
    <div className="w-100 px-3">
      <div className="d-flex align-items-start gap-2 pt-3">
        <BreadCrumbs
          breadCrumbActive={'Unit Produksi'}
          breadCrumbParent={'Pengaturan'}
          breadCrumbParentLink={'/pengaturan-profile'}
        />
      </div>
      <div className="d-flex flex-column gap-2 mb-2">
        <Card className="border-0 shadow-sm">
          <CardBody>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h5>Unit Produksi</h5>
            </div>

            <TableProductionUnit userId={profile?.userId} />
          </CardBody>
        </Card>
      </div>
    </div>
  )
}

export default ProductionUnit
